module.exports = "/images/question-regular.svg?727839b0e3c83985c2278c040b70668f";